import interfaceUser from './interface-user'
import interfaceList from './interface-list' //课程列表

let mergeInterface = Object.assign({}, interfaceUser, interfaceList)

export default mergeInterface



// WEBPACK FOOTER //
// ./src/api/interface.js